import Badge from './Badge';

/**
 * One status→color mapping, shared by every status word in the app
 * (investment, KYC, support ticket, payment/payout) instead of each screen
 * inventing its own tone map. Per the design system:
 *   Success/Active/Approved/Resolved  -> green
 *   Pending/In-progress/Open          -> amber
 *   Rejected/Closed/Cancelled/Failed  -> red (reserved for negative states)
 *   Neutral/Matured/Info              -> slate
 * Unrecognized values fall back to neutral gray rather than guessing.
 */
const STATUS_TONE = {
  // green
  active: 'success',
  approved: 'success',
  resolved: 'success',
  success: 'success',
  verified: 'success',
  // amber
  pending: 'warning',
  pending_funding: 'warning',
  pending_approval: 'warning',
  open: 'warning',
  in_progress: 'warning',
  // red — grouped with rejected/cancelled/failed per the design system,
  // even where "closed" is a normal terminal state rather than a failure.
  rejected: 'danger',
  closed: 'danger',
  cancelled: 'danger',
  canceled: 'danger',
  failed: 'danger',
  // slate
  matured: 'info',
};

export function statusPillTone(status) {
  return STATUS_TONE[status] || 'neutral';
}

export default function StatusPill({ status, label, className }) {
  const text = label || (status ? status.replace(/_/g, ' ').toUpperCase() : 'UNKNOWN');
  return (
    <Badge tone={statusPillTone(status)} className={className}>
      {text}
    </Badge>
  );
}
